import React from "react"
import types from "prop-types"
import TruncatedWithTooltip from "shared/TruncatedWithTooltip"

const LongTextDataElement = ({ value = "", rowData = undefined, rowHrefFunc = undefined }) => {
  const text = <TruncatedWithTooltip className="block" text={value} />

  if (!rowHrefFunc) {
    return text
  }

  // Sits above the row-link overlay so the text can be hovered. The href keeps it clickable.
  return (
    <a className="relative block text-inherit no-underline" href={rowHrefFunc(rowData)}>
      {text}
    </a>
  )
}

LongTextDataElement.propTypes = {
  value: types.string,
  // eslint-disable-next-line react/forbid-prop-types
  rowData: types.object,
  rowHrefFunc: types.func,
}

export default LongTextDataElement
